<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheSidebar />
    <!--    <TheAside/>-->
    <CWrapper ref="navWrapper">
      <!-- <div class="fixed-notification" id="notificationFixed">
        <marquee v-if="isShowNotificationEmergency" :text="combinedNotificationEmergencyText()" :loop="true"
          :translateX="['100%', '-100%']" :easing="'linear'" :backgroundColor="'red'">
        </marquee>
        <marquee v-else :text="combinedNotificationNormalText()" :loop="true" :translateX="['100%', '-100%']"
          :easing="'linear'" :backgroundColor="'#FFF3CD'" :color="'#664D03'">
        </marquee>
      </div> -->
      <TheHeader />
      <div class="c-body" id="headerNav">
        <CModal title="Kiểm tra log thiết bị" :show.sync="isShowModalLogDevice" :closeOnBackdrop="false" :size="'sm'">
          <CRow class="pb-2">
            <span style="font-weight: bold;">Bạn có muốn tải file log xuống không?</span>
          </CRow>
          <template v-slot:footer>
            <button type="button" class="btn btn-secondary" @click="isShowModalLogDevice = false"><i
                class="fa fa-times"></i> Hủy bỏ
            </button>
            <button type="button" class="btn btn-primary" @click="downLoadLog()"><i class="fa fa-check"></i>
              Có
            </button>
          </template>
        </CModal>
        <main class="c-main mt-1">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter />
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAside from './TheAside'
import { authLogout, authAutoLogout } from "@/security/index";
import { ACCESS_TOKEN_EXPIRED, HOTLINE, NOTIFICATION_EMERGENCY } from '../constant'
import Marquee from '@/views/base/Marquee.vue';
import { mapActions } from 'vuex';

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAside,
    Marquee
  },
  data() {
    return {
      intervalAutoLogout: null,
      isRefreshingSession: false,
      intervalTimes: null,
      intervalHiddenNotification: null,
      showNotification: this.$helper.formatDateDetail(new Date()),
      isShowNotificationEmergency: false,
      notificationEmergency: null,
      maxDisplayDeviceTable: 5,
      isShowModalLogDevice: false,
      log: {
        deviceCode: '',
        logUri: ''
      }
    }
  },
  mounted() {
    // this.scrollNotification();
    this.countAutoLogout();
    this.connectWebSocket();
    this.countdownTimes();

    if (localStorage.getItem(NOTIFICATION_EMERGENCY) != null) {
      this.isShowNotificationEmergency = true;
      this.notificationEmergency = JSON.parse(localStorage.getItem(NOTIFICATION_EMERGENCY));
    }

  },
  methods: {
    combinedNotificationEmergencyText() {

      var devices = this.viewDevice(this.notificationEmergency.devices);

      var deviceString = "";

      for (var i = 0; i < devices.length; i++) {
        deviceString = deviceString + devices[i] + ", "
      }

      if (this.notificationEmergency.devices.length > this.maxDisplayDeviceTable) {
        deviceString += "..."
      }

      return `Địa bàn của bạn đang có bản tin vừa được đặt khẩn cấp từ người dùng cấp trên - ${this.notificationEmergency.locationName}. Bản tin sẽ kết thúc vào lúc ${this.notificationEmergency.times}, trên các thiết bị : ` + deviceString + `nếu người dùng đang phát trực tiếp, vui lòng kết thúc nếu không cần thiết để bản tin không bị gián đoạn!`;
    },
    combinedNotificationNormalText() {
      return `Hôm nay, ${this.showNotification}. Chúc người dùng có 1 ngày làm việc hiệu quả và thành công. Nếu có bất cứ vấn đề liên quan đến hệ thống hoặc hư hỏng, vui lòng liên hệ theo số hotline: ${HOTLINE}`;
    },
    countdownShowNotification() {
      this.intervalHiddenNotification = setInterval(() => {
        var notificationEmergency = JSON.parse(localStorage.getItem(NOTIFICATION_EMERGENCY));
        if (notificationEmergency != null && notificationEmergency.timeExpired != null) {
          if (new Date(notificationEmergency.timeExpired) <= new Date()) {
            this.isShowNotificationEmergency = false;
            localStorage.removeItem(NOTIFICATION_EMERGENCY);
          }
        } else {
          this.isShowNotificationEmergency = false;
          clearInterval(this.intervalHiddenNotification);
        }
      }, 1000);
    },
    countdownTimes() {
      this.intervalTimes = setInterval(() => {
        this.showNotification = this.$helper.formatDateDetail(new Date());
      }, 1000);
    },
    viewDevice(item) {
      if (!item) {
        return [];
      }
      if (item.length <= this.maxDisplayDeviceTable) {
        return item;
      }
      return item.slice(0, this.maxDisplayDeviceTable);
    },
    scrollNotification() {
      window.addEventListener('scroll', () => {
        var doc = document.getElementById('headerNav');
        var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (top <= 10) {
          document.getElementById("notificationFixed").style.position = '';
        } else {
          document.getElementById("notificationFixed").style.position = 'fixed';
        }
      });
    },
    ...mapActions(['triggerCloseStream']),
    tryRefreshSession() {
      if (this.isRefreshingSession) {
        return;
      }
      this.isRefreshingSession = true;
      this.$helper.refreshAccessToken()
        .catch(() => {
          authAutoLogout();
        })
        .finally(() => {
          this.isRefreshingSession = false;
        });
    },
    countAutoLogout() {
      this.intervalAutoLogout = setInterval(() => {
        const expToken = localStorage.getItem(ACCESS_TOKEN_EXPIRED);
        if (!expToken) {
          return;
        }
        const expiredTimeMs = this.$helper.toTimestamp(expToken);
        if (!expiredTimeMs) {
          return;
        }
        const nowMs = Date.now();
        const oneMinuteInMillis = 60 * 1000;
        const thirtySecondsInMillis = 30 * 1000;

        if (nowMs + oneMinuteInMillis >= expiredTimeMs) {
          this.triggerCloseStream();
        }

        // Ưu tiên refresh trước khi token hết hạn để tránh auto-logout nhầm.
        if (nowMs + thirtySecondsInMillis >= expiredTimeMs) {
          this.tryRefreshSession();
        }
      }, 1000);
    },
    downLoadLog() {
      this.isShowModalLogDevice = false;
      if (this.log.logUri && this.log.logUri.length > 0) {
        // this.$helper.downloadLog(this.log.logUri, 'LOG_' + this.log.deviceCode + '.log');
        window.open(this.log.logUri, "_blank");
      }
      setTimeout(() => {
        this.log.logUri = '';
      }, 1000)

    },
    connectWebSocket: function () {
      let that = this
      that.$connectSocket(successCallback => {
        if (successCallback) {
          successCallback.subscribe("/user/notification", notification => {
            that.$store.commit('setDataNotification', notification)
          });
          that.$sendMessageSocket("/app/server.message.notification", null, {})

          successCallback.subscribe("/user/notification-emergency", notification => {
            if (notification.body !== '') {
              this.isShowNotificationEmergency = true;
              let data = JSON.parse(notification.body)
              this.notificationEmergency = {
                devices: data.devices,
                locationName: data.locationName,
                times: data.endTimes,
                timeExpired: this.$helper.plusDateTime(5, 'm')
              }
              localStorage.setItem(NOTIFICATION_EMERGENCY, JSON.stringify(this.notificationEmergency));
              this.countdownShowNotification();
            } else {
              localStorage.removeItem(NOTIFICATION_EMERGENCY);
              clearInterval(this.intervalHiddenNotification);
            }
          })
          that.$sendMessageSocket("/app/server.message.notification-emergency", null, {})

          successCallback.subscribe("/notification", notification => {
            that.$store.commit('setDataNotification', notification)
          });
          successCallback.subscribe("/ping", ping => {
          });
          successCallback.subscribe("/user/devices/live", liveMessage => {
            let data = JSON.parse(liveMessage.body)
            that.$store.commit('setDataLiveStreamMessage', data)
          });
          successCallback.subscribe("/user/enable-user", user => {
            let data = JSON.parse(user.body)
            that.$store.commit('setBlockUser', data.data.blocked)
          });
          successCallback.subscribe("/user/devices/get-log", logDevice => {
            let data = JSON.parse(logDevice.body)
            that.log.deviceCode = data.deviceCode;
            that.log.logUri = data.urlLog;
            if (that.$store.state.logDevice) {
              that.isShowModalLogDevice = true;
            }
            // that.$store.commit('setLogDevice', data)
          });
          successCallback.subscribe("/user/at-cmd", atCmd => {
            let data = JSON.parse(atCmd.body)
            that.$store.commit('set', ['atCmd', data])
          });
        }
      }, errorCallback => {
        console.log(errorCallback)
      })
    },
  },
  destroyed() {
    clearInterval(this.intervalAutoLogout);
    clearInterval(this.intervalTimes);
  },
  computed: {},
  watch: {
    '$store.state.reconnectSocket': function (value) {
      if (value) {
        this.connectWebSocket();
      }
      this.$store.commit("set", ["reconnectSocket", false])
    },
  }
}
</script>

<style scoped>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
